import { addMessages } from '@hana/i18n';

// Khoá chuỗi mque.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'mque.1': "Gắn",
  'mque.2': "Tạo dòng phát sinh",
  'mque.3': "Hỏi Hana tìm job",
});
addMessages('en', {
  'mque.1': "Attach",
  'mque.2': "Create adjustment line",
  'mque.3': "Ask Hana to find job",
});
